import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Container } from './styles';
import { usePosts } from './props';

import { useHistory } from 'react-router';

import Post from '../post';

function RecommendedPostsController() {
  const { isLoading, posts } = usePosts();

  return <RecommendedPosts isLoading={isLoading} posts={posts} />;
}

function RecommendedPosts({ posts, isLoading }) {
  const { push } = useHistory();

  return (
    <Container>
      <h3 className="container-title">Artigos Recomendados</h3>

      <div className="posts">
        {posts.map(post => (
          <Post className="posts__item" key={post.id} {...post} />
        ))}

        {(!posts || posts.length === 0) && (
          <div className="container-feedback">
            {isLoading ? <CircularProgress /> : 'Nenhum artigo para exibir :('}
          </div>
        )}
        <button className="posts__button" onClick={() => push('/artigos')}>
          Ver Todos
        </button>
      </div>
    </Container>
  );
}

export default RecommendedPostsController;
